import { useAppVersionSync } from '../../hooks/useAppVersionSync';

export default function AppVersionSyncMount(): null {
  useAppVersionSync();
  return null;
}
